"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getFileKind = getFileKind;
exports.isPreviewableInline = isPreviewableInline;
exports.markMessageFailed = markMessageFailed;
exports.reconcileOptimisticMessage = reconcileOptimisticMessage;
exports.removeMessageById = removeMessageById;
exports.replaceMessageById = replaceMessageById;
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
const IMAGE_EXTENSIONS = new Set(["jpg", "jpeg", "png", "gif", "bmp", "tiff", "tif", "webp", "heif", "heic", "raw", "svg", "apng", "ico", "exr"]);
const SPREADSHEET_EXTENSIONS = new Set(["xlsx", "xlsm", "xlsb", "xltx", "xls"]);
function getExtension() {
  let fileName = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "";
  const parts = fileName.split(".");
  return parts.length > 1 ? parts.pop().toLowerCase() : "";
}

// Pure classification only — no asset paths here. Each app's presentational
// layer maps the returned kind to its own icon asset.
function getFileKind() {
  let fileName = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "";
  const extension = getExtension(fileName);
  if (IMAGE_EXTENSIONS.has(extension)) return "image";
  if (extension === "pdf") return "pdf";
  if (SPREADSHEET_EXTENSIONS.has(extension)) return "spreadsheet";
  return "document";
}
function isPreviewableInline() {
  let fileName = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "";
  return getFileKind(fileName) === "image";
}

// Replace a message identified by id (real _id or the optimistic tempId)
// with an updated version. Returns the original array reference if no match
// is found, so callers can skip a state update when nothing changed.
function replaceMessageById(messages, id, updater) {
  const index = messages.findIndex(message => message.id === id || message.tempId === id);
  if (index === -1) return messages;
  const updated = typeof updater === "function" ? updater(messages[index]) : updater;
  return [...messages.slice(0, index), updated, ...messages.slice(index + 1)];
}
function removeMessageById(messages, id) {
  const index = messages.findIndex(message => message.id === id || message.tempId === id);
  if (index === -1) return messages;
  return [...messages.slice(0, index), ...messages.slice(index + 1)];
}

// Reconciles an optimistic (tempId-keyed) message with the server-confirmed
// version once the REST call resolves, matching by tempId rather than id
// since the server assigns the real id only on success.
function reconcileOptimisticMessage(messages, tempId, confirmedMessage) {
  return replaceMessageById(messages, tempId, () => confirmedMessage);
}
function markMessageFailed(messages, tempId) {
  return replaceMessageById(messages, tempId, message => _objectSpread(_objectSpread({}, message), {}, {
    status: "failed"
  }));
}